import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { LEGAL_LINKS } from "../lib/legal";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr(""); setLoading(true);
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setMsg(data.message);
            setDone(true);
        } catch (e2) {
            setErr(formatApiError(e2.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-white p-8" data-testid="forgot-password-page">
            <div className="w-full max-w-md fade-up">
                <img src="/logo-full.png" alt="Asta Intelligence" className="h-24 w-auto mix-blend-screen mb-5" />
                <h1 className="font-display-black text-3xl sm:text-4xl mb-3 leading-[0.95]">Password dimenticata?</h1>
                <p className="text-sm text-gray-600 mb-8 leading-relaxed">
                    Inserisci la tua email: ti invieremo un link sicuro per reimpostare la password (valido 1 ora).
                </p>

                {done ? (
                    <div data-testid="forgot-password-success" className="border border-emerald-200 bg-emerald-50 text-emerald-800 text-sm px-4 py-3 rounded-lg">
                        {msg}
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-password-form">
                        <div>
                            <label className="overline block mb-2">Email</label>
                            <input
                                data-testid="forgot-password-email-input"
                                type="email" required autoComplete="email"
                                value={email} onChange={(e) => setEmail(e.target.value)}
                                className="w-full h-11 px-3 border border-gray-300 bg-white text-sm focus:border-black focus:outline-none transition-colors"
                                placeholder="nome@studio.it"
                            />
                        </div>
                        {err && <div data-testid="forgot-password-error" className="border border-red-200 bg-red-50 text-red-700 text-xs px-3 py-2">{err}</div>}
                        <button
                            data-testid="forgot-password-submit"
                            type="submit" disabled={loading}
                            className="w-full h-11 bg-black text-white text-sm font-semibold hover:bg-gray-800 disabled:opacity-40 transition-colors rounded-lg"
                        >
                            {loading ? "Invio in corso…" : "Invia link di reset"}
                        </button>
                    </form>
                )}

                <div className="mt-8 pt-6 border-t border-gray-200 text-xs text-gray-600">
                    <Link to="/login" data-testid="back-to-login-link" className="font-semibold underline underline-offset-4 hover:text-black">
                        ← Torna al login
                    </Link>
                </div>
                <nav className="mt-4 flex flex-wrap gap-x-4 gap-y-1 text-[11px]">
                    {LEGAL_LINKS.map((l) => (
                        <Link key={l.to} to={l.to} className="text-gray-400 hover:text-black underline underline-offset-4">{l.label}</Link>
                    ))}
                </nav>
            </div>
        </div>
    );
}
